import { AvailabilityFilters } from 'webReservations/availability/AvailabilityFilters';
import { AvailabilityNavigator } from 'webReservations/availability/AvailabilityNavigator';
import { InteractiveGuestFloorPlan } from 'webReservations/components/InteractiveGuestFloorPlan';
import { RestaurantHero } from 'webReservations/components/RestaurantHero';
import { Unauthenticated } from 'webReservations/components/Unauthenticated';
import { useAvailabilityContext } from 'webReservations/context/AvailabilityContext';
import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import { useUserContext } from 'webReservations/context/UserContext';
import { NotFoundPage } from 'webReservations/errors/NotFound/NotFoundPage';
import { MobileFilterControl } from 'webReservations/filters/MobileFilterControl';
import { useReservationDetails } from 'webReservations/hooks/useReservationDetails';
import { Layout } from 'webReservations/layout/Layout';
import { FloorPlanSelector } from '@components/floorPlan/FloorPlanSelector';
import { LoadingPage } from '@components/LoadingPage';
import { WideView } from '@components/wideView/WideView';
import { OriginalReservationCard } from './OriginalReservationCard';
import styles from './ReservationEditPage.scss';

export const ReservationEditPage = () => {
  const { isAuthenticated } = useUserContext();
  const { restaurantDetails: restaurant } = useRestaurantContext();
  const { data: reservation, isLoading: isReservationLoading } =
    useReservationDetails();

  const { floorPlans, selectedFloorPlan, setSelectedFloorPlanId } =
    useAvailabilityContext();

  if (!isAuthenticated) {
    return (
      <Layout>
        <Unauthenticated title="Log in to view your reservations" subtitle="" />
      </Layout>
    );
  }

  if (isReservationLoading) {
    return <LoadingPage />;
  }

  if (!reservation || !restaurant) {
    return <NotFoundPage />;
  }

  return (
    <Layout hideBorder className={styles.layout}>
      <main className={styles.container}>
        <RestaurantHero restaurant={reservation.restaurant} />
        <div className={styles.content}>
          <div className={styles.body}>
            <div className={styles.pageBody}>
              <WideView
                narrowElement={
                  <OriginalReservationCard reservation={reservation} />
                }
              />
              <div className={styles.floorPlanContainer}>
                <FloorPlanSelector
                  floorPlans={floorPlans}
                  selectedFloorPlan={selectedFloorPlan}
                  onChange={setSelectedFloorPlanId}
                />

                {selectedFloorPlan && (
                  <InteractiveGuestFloorPlan
                    backgroundSrc={selectedFloorPlan.backgroundSrc}
                    tables={selectedFloorPlan.floorPlanTables}
                    restaurantId={reservation.restaurant.id}
                  />
                )}
                <WideView narrowElement={<MobileFilterControl />} />
              </div>
              <div className={styles.sideContent}>
                <WideView
                  wideElement={
                    <>
                      <OriginalReservationCard reservation={reservation} />
                      <AvailabilityFilters />
                    </>
                  }
                />
                <AvailabilityNavigator />
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};
